/**
 * @hidden
 * Error codes that can be thrown from externalAppCommands and externalAppCardCommands Action Submit specifically
 * @internal
 * Limited to Microsoft-internal use
 */
export enum ExternalAppErrorCode {
  INTERNAL_ERROR = 'INTERNAL_ERROR', // Generic error
}
